const Form059EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        ApplicationInfo: "School Info",
        PartA: "Indication of Preference for Pairing Up with Mainland Schools",
        // PartB: "Part B:School Characteristics",
        PartB: "Reporting Form on Mainland Sister Schools",
        // OtherReason: "The attachment",
        Confirmation: "Confirmation",
    },
    importantNotesTemp: {
        noteOne: "1. This e-form is for the online submission of:",
        noteOne_a: "Grant for the Sister School Scheme Application Form",
        noteOne_b: "Reporting Form on Mainland Sister Schools",
        noteOne_c:
            "Indication of Preference for Pairing Up with Mainland Schools",
        noteTwo:
            "2. Before filling in the form, please refer to the Education Bureau Circular No. 9/2025 ‘Life-wide Learning and Sister School Grant’",
        noteTwo_a:
            "https://applications.edb.gov.hk/circular/upload/EDBC/EDBC25009E.pdf",
        noteThree:
            "3. If the total file size of all documents in an electronic submission exceeds the upload limit of 10MB, schools should split the submission into several submissions not exceeding the upload limit on each occasion.",
        noteFour:
            "4. EDB may not be able to process the application in case the schools fail to provide mandatory data.",
        noteFive:
            "5. Schools should pay attention to the name of the teacher in-charge of the Sister School Scheme provided in the e-form for future contact by EDB officers regarding the grant.",
        noteSix:
            "6. For enquiries, please contact the School Development Support Section of EDB:",
        noteSix_a:
            "Address: 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong",
        noteSix_b: "Telephone: 3509 8482",
        noteSix_c: "Fax: 2891 2593",
        noteSix_d: "Email: sds1@edb.gov.hk",
    },

    importantNotes: {
        p1_1: "Personal Information Collection Statement",
        p1_2: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",

        p1_a: "processing employment-related matters;",
        p1_b: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        p1_c: "auditing;",
        p1_d: "conducting research and compiling statistics to facilitate planning of education services;",
        p1_e: "processing matters relating to the development of the education profession;",
        p1_f: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",

        p2: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        p3: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
        p4: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        p5: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },

    label: {
        iamStatement:
            "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application. If you or the approving authority of the school do not have “iAM Smart+” account, you may download the paper form <a href='https://www.edb.gov.hk/en/sch-admin/admin/about-sch/sister-sch-scheme/sister-sch-scheme-index.html' style='color:black;' target='_blank'><b><u>here</b></u></a> and submit it by post.",
        subjectArea: "Subject area",
        statement:
            "I have read, understand and agree to the above terms and conditions",
        applicationForm: "School Information",
        partALocationOne: "Location",
        PartBSchoolCharacteristics: "School Characteristics",
        partCSchoolInformation: "Mainland sister school information",

        UploadSigningImage: "UploadSigningImage",
        eSigning: "ESigning",
        iamSmart: "IamSmart",

        rewardOption: {
            schoolInRemoteArea: "School in remote area",
            experimentalSchool: "Experimental School",
            foreignLanguageSchool: "Foreign language School",
            vocationalEducation: "Vocational education",
            technologyEducation: "Technology education",
            sports: "Sports",
            arts: "Arts",
            subjectArea: "Subject area (please specify:)",
            others: "Others (please specify:)",
            noApecificChoice: "No specific choice",
        },

        // schoolChoice: {
        //     OurSchoolHasJoined: "Our school has joined",
        //     TheSisterSchoolScheme: "The Sister School Scheme",
        //     ThePilotScheme: "The Pilot Scheme",
        // },

        // schoolChoiceType: {
        //     schoolChoiceTypeA:
        //         "Our school has not joined the Sister School Scheme or the Pilot Scheme yet, but has already paired up with Mainland schools as sister schools (Please also submit Annex 5).",
        //     schoolChoiceTypeB:
        //         "Our school has no sister school in the Mainland and would like to pair up with Mainland schools as sister schools through the coordination of EDB (Please also submit Annex 6).",
        // },

        schoolAllChoiceTypeA: {
            schoolChoiceTypeA:
                "now applies for the Grant for the Sister School Scheme.",
        },

        schoolAllChoiceType: {
            schoolChoiceTypeC:
                "now submits the Indication of Preference for Pairing Up with Mainland Schools.",
            schoolChoiceTypeB:
                "now submits the Reporting Form on Mainland Sister Schools.",
        },

        schoolAllChoice: {
            hasJoined: "Our school has joined the Sister School Scheme",
        },
        schoolAllChoiceTemp: {
            hasNotJoined:
                "Our school has not joined the Sister School Scheme yet, but has already paired up with Mainland schools as sister schools",
            noSisterSchool:
                "Our school has no sister school in the Mainland and would like to pair up with Mainland schools as sister schools through the coordination of EDB",
        },
        pleaseSpecifycity: "Please specify City",
        pleaseSpecify: "Please specify",
        government: "Government",
        aided: "Aided",
        dss: "DSS",
        caput: "Caput",
        secondary: "Secondary",
        primary: "Primary",
        special: "Special",
        schoolType: "School Type:",
        schoolTypeOption: {
            secondary: "Secondary",
            primary: "Primary",
            special: "Special",
        },
        financeType: "Finance Type:",
        financeTypeOption: {
            government: "Government",
            aided: "Aided",
            dss: "DSS",
            caput: "Caput",
        },
        schoolAddress: "School Address",
        schoolTel: "School Tel",
        schoolFax: "School Fax No.",
        schoolName: "Name of School",
        telephone: "School Telephone No.",
        schoolEmailAddress: "School Email Address",
        nameOfPrincipal: "Name of Principal",
        teacherName: "Name of Supervisor/SMC Chairman",
        teacherPost:
            "Post of Teacher-in-charge of the Sister School/the E-platform:",
        platformName:
            "Name of Teacher-in-charge of the Sister School / the E-platform",
        tooltips:
            "E-platform refers to the Electronic Platform for Sister Schools set up by EDB. EDB will contact the teacher-in-charge in due course about the creation of a user account.  (Only applicable to those schools that have no user account.)",
        partaTooltips:
            "Please put down the preference from 1 to 8 in the boxes below",
        platform:
            "Post of Teacher-in-charge of the Sister School / the E-platform:",
        platformType: {
            VicePrincipal: "Vice-principal",
            seniorTeacher: "Senior teacher",
            teacher: "Teacher",
            others: "Others",
        },
        post: "post",
        management:
            "Endorsed by our Incorporated Management Committee (IMC) / School Management Committee (SMC), our school:",
        managementType: {
            yes: "yes",
            no: "no",
        },
        platformNameNotes:
            "E-platform refers to the Electronic Platform for Sister Schools set up by EDB. EDB will contact the teacher-in-charge in due course about the creation of a user account. (Only applicable to those schools that have no user account.)",
        platformNotes:
            "E-platform refers to the Electronic Platform for Sister Schools set up by EDB. EDB will contact the teacher-in-charge in due course about the creation of a user account.(Only applicable to those schools that have no user account.)",
        pleaseSelectAPlan: "Please select a plan",
        partaNotes:
            "We would like to form sister school pair(s) through the coordination of EDB. Our preference is as follows:",
        partAlabel: {
            pleaseSpecify: "Please specify:",
            location: "Location",
            preference: "Preference",
            notes: "Refers to Guangzhou, Shenzhen, Zhuhai, Foshan, Huizhou, Dongguan, Zhongshan, Jiangmen and Zhaoqing",
            locationList: {
                sichuanProvince: "Sichuan Province",
                hainanProvince: "Hainan Province",
                shanghaiMunicipality: "Shanghai Municipality",
                beijingMunicipality: "Beijing Municipality",
                fujianProvince: "Fujian Province",
                bayArea: "Bay Area",
                citiesInOtherGuangdongProvinc:
                    "Cities in Other Guangdong Province (please specify:)",
                otherProvincesOrcities:
                    "Other Provinces or Cities (please specify:)",
            },
            otherGuangdongCitiesSpecifyOne:
                "Cities in Other Guangdong Provinces 1",
            otherGuangdongCitiesSpecifyTwo:
                "Cities in Other Guangdong Provinces 2",
            otherGuangdongCitiesSpecifyThree:
                "Cities in Other Guangdong Provinces 3",
            otherGuangdongCitiesSpecifyFour:
                "Cities in Other Guangdong Provinces 4",
            otherGuangdongCitiesSpecifyFive:
                "Cities in Other Guangdong Provinces 5",

            otherProvincesOrcitiesSpecifyOne: "Other Provinces Or cities 1",
            otherProvincesOrcitiesSpecifyTwo: "Other Provinces Or cities 2",
            otherProvincesOrcitiesSpecifyThree: "Other Provinces Or cities 3",
            otherProvincesOrcitiesSpecifyFour: "Other Provinces Or cities 4",
            otherProvincesOrcitiesSpecifyFive: "Other Provinces Or cities 5",
            city: "city",
            provinceOrCity: "province or city",
        },

        schoolAllSelect: {
            schoolChoiceTypeA:
                "now applies for the Grant for the Sister School Scheme.",
            schoolChoiceTypeC:
                "now submits the Indication of Preference for Pairing Up with Mainland Schools.",
            schoolChoiceTypeB:
                "now submits the Reporting Form on Mainland Sister Schools.",
            hasJoined: "Our school has joined the Sister School Scheme.",
            hasNotJoined:
                "Our school has not joined the Sister School Scheme yet, but has already paired up with Mainland schools as sister schools.",
            noSisterSchool:
                "Our school has no sister school in the Mainland and would like to pair up with Mainland schools as sister schools through the coordination of EDB.",
        },
        partBlabel: {
            notes: " We understand that the preferences indicated above are used as reference for pairing only and the final result of  pairing is subject to the actual circumstances. Should we have very special reasons for not pairing up with the school  arranged by EDB, we will inform and explain to EDB in writing.",
            PleaseSpecify: "Please specify",
        },
        partClabel: {
            schoolName: "Name of Sister School",
            schoolType: "School Type:",
            yearOfFormingSisterSchool: "Year of Forming Sister School",
            province: "Province",
            city: "City",
            area: "Area",
            ourSchool: "Our School:",
            and: "and:",
            partcJoin: {
                hasJoined: "has joined the Sister School Scheme.",
                hasNotJoined: "has not joined the Sister School Scheme.",
            },

            partcPair: {
                hasPaired:
                    "has paired up with Mainland schools as sister schools.",
                hasNewlyPaired:
                    "has newly paired up with Mainland schools as sister schools.",
            },
            supportDocs: "Supporting Documents",
        },
        schoolChoose: {
            locationProvinces:
                "Forming sister school pair(s) according to the preference below",
            AnyProvinces: "Any provinces or cities arranged by EDB",
        },
        location: "Location of Sister School",
        schoolInfomation:
            "Our School has <b>paired up / newly paired up</b> with Mainland schools as sister schools with details as follows:",
    },
    errorMsg: {
        abOrc: "Please check either a) or b)/c)",
        prefDistinct: "All location preference should be different",
        emptyPreference: "Please input your preference",
        order: "Please enter the number in order",
        dialogTitle: "Failure",
        dialogContent:
            "When other than the Reporting Forms on Mainland Sister School is selected, only supervisors can sign the application.",
        dialogContentForOnlyOption3:
            "When only the Reporting Forms on Mainland Sister School is selected, only school head can sign the application.",
    },
};
export default Form059EN;
